import { MEDIA_GENERATOR_VENDOR_LABEL, modelsFor, type MediaGeneratorKey } from '@mg/shared';

/**
 * The generators offered for a design's imagery.
 *
 * The same set Generate media offers while the built-in generator is switched on, deliberately —
 * someone who has a favourite there should find it here. Unlike Generate media, this list keeps
 * Smorgas Social · FLUX when image generation is switched off on the install (App Settings → AI
 * models): which of them can return in time is a separate question the server answers — an async
 * provider, or FLUX switched off, degrades to a flat background with a message rather than being
 * hidden, because a missing option reads as a bug while an explained one reads as a limit.
 *
 * Filtered to generators that actually publish models, so the Model select is never empty.
 */
export const IMAGE_GENERATORS: { key: MediaGeneratorKey; label: string }[] = (
  ['azure', 'MAGNIFIC', 'REPLICATE', 'FAL', 'OPENAI', 'STABILITY'] as MediaGeneratorKey[]
)
  .filter((key) => modelsFor(key).length > 0)
  .map((key) => ({
    key,
    label:
      key === 'azure'
        ? 'Smorgas Social · FLUX'
        : ((MEDIA_GENERATOR_VENDOR_LABEL as Record<string, string>)[key] ?? String(key)),
  }));
